import React from "react";

import { PickerLocalization } from "modules/common/components/pickerLocalization";
import { AUDIENCE_ANALYTICS_MIN_DATE } from "utils/analyticsHelpers";
import { List } from "@mui/material";
import { CustomRangeFilterOptions } from "modules/insights";

import DatePicker from "modules/common/components/forms/inputs/datePicker";
import moment from "moment";
import MoreOptionsButton from "modules/common/components/buttons/moreOptionsButton";
import MoreOptionsItem from "modules/common/components/moreOptionsItem";

import "./styles/customDateRange.sass";

interface CustomDateRangeFilterProps {
    options: { value: CustomRangeFilterOptions; label: string }[];
    selectedValue: CustomRangeFilterOptions;
    selectedDate: moment.Moment;
    onSelect: (value: CustomRangeFilterOptions) => void;
    onDateChange: (date: moment.Moment | null, isCustom: boolean) => void;
}

const CustomDateRangeFilter = ({ options, selectedValue, selectedDate, onSelect, onDateChange }: CustomDateRangeFilterProps) => {
    //Changes the month on the selected date.
    const handleMonthChange = (value: string | undefined) => {
        if (value) {
            const newMonth = moment(value).month();
            const newDate = selectedDate.clone().month(newMonth);
            onDateChange(newDate, true);
        }
    };
    //Changes the year on the selected date.
    const handleYearChange = (value: string | undefined) => {
        if (value) {
            const newYear = moment(value).year();
            const newDate = selectedDate.clone().year(newYear);
            onDateChange(newDate, true);
        }
    };

    return (
        <PickerLocalization>
            <div>
                <MoreOptionsButton text={options.find((opt) => opt.value === selectedValue)?.label ?? ""} className="moreOptionsButton-ml">
                    <List disablePadding>
                        {options.map((opt) => (
                            <MoreOptionsItem key={`${opt.value}-${opt.label}`} text={opt.label} onClick={() => onSelect(opt.value)} />
                        ))}
                    </List>
                </MoreOptionsButton>
            </div>
            <div className="calendar-section">
                <div className="calendar-element">
                    <DatePicker
                        hideHeader
                        format={"MMMM"}
                        maxDate={moment().endOf("month").endOf("day")}
                        date={selectedDate.toISOString()}
                        minDate={AUDIENCE_ANALYTICS_MIN_DATE}
                        views={["month"]}
                        onChangeDate={handleMonthChange} // Only changes month
                    />
                </div>
                <div className="calendar-element custom-date-range-calendar">
                    <DatePicker
                        hideHeader
                        format={"yyyy"}
                        views={["year"]}
                        minDate={AUDIENCE_ANALYTICS_MIN_DATE}
                        date={selectedDate.toISOString()}
                        maxDate={moment().endOf("month").endOf("day")}
                        onChangeDate={handleYearChange}
                    />
                </div>
            </div>
        </PickerLocalization>
    );
};

export default CustomDateRangeFilter;
